<script>
    import {links} from "svelte-routing";
    import SvelteSeo from "svelte-seo";

</script>

<svelte:head>
    <title>Fehler 404 - Seite nicht gefunden</title>
</svelte:head>

<SvelteSeo
        title="Fehler 404 - Seite nicht gefunden"
        description="Es tut uns leid, aber wir konnten die von Ihnen aufgerufene Seite nicht finden."
        noindex={true}
        nofollow={true}
/>

<div class="container site-content" use:links>

    <div class="row">

        <div class="col">
            <div class="site-section px-4 py-4 rounded">

                <article class="px-0 py-2 mb-3 bg-transparent">

                    <div class="mb-4 pb-0 border-bottom border-lightdark">
                        <h2 class="mb-3 site-header"><i class="fas fa-exclamation-triangle me-1"></i> Fehler 404 - Seite nicht gefunden</h2>
                    </div>

                    <div class="row">
                        <div class="col">
                            <p>
                                Hoppla! Da ist wohl eine Milchkanne umgefallen – die von Ihnen gesuchte Seite gibt's nicht mehr oder ist auf Wanderschaft gegangen.
                            </p>
                            <p>
                                Vielleicht wurde sie ins Regal umgeräumt oder Sie haben sich beim Tippen des Links vertippt. Kein Problem!
                            </p>
                            <p>
                                <a href="/">&#x203A; Zur Startseite</a><br>
                                <a href="/site/Anfahrt+%26+Kontakt-m-57">&#x203A; Kontakt aufnehmen</a>
                            </p>
                            <p>Oder schnuppern Sie doch mal hier rein:</p>
                            <p>
                                <a href="/site/Angebote-m-103">&#x203A; Wochenangebote</a><br>
                                <a href="/site/Aktuelles-m-108">&#x203A; Aktuelle Informationen</a><br>
                                <a href="/site/%26Uuml%3Bber+uns-m-104">&#x203A; Über den Dorfladen Gungolding</a>
                            </p>
                        </div>

                    </div>

                </article>

            </div>
        </div>

    </div>

</div>
